import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Person from './Person';
import config from 'config';
var NotificationsCollection = Backbone.Collection.extend({
    model: Backbone.Model,

    initialize: function(attributes, options){
        _.bindAll(this, 'setNotifications');
        this.listenTo(this, 'sync', this.setNotifications);
        this._meta = {};
    },

    url: function() {
        var base = config.baseV2Url + '/messages?eventId=' + this._meta.event.get('id') + '&notifications=true';
        return base;
    },

    setNotifications: function(){
        this.each(function(notification){
            var contentType = notification.get('contentType');
            if (contentType == 'organizer_push' || contentType == 'reminder_to_checkin' || contentType == 'download_notification' || contentType == 'welcome_notification') {
                notification.set(
                    {
                        'photo-url': Global.get('event').get('header-logo-url'),
                        'name': Global.get('event').get('name')
                    }
                );

            } else if (contentType == 'connection_rsvped_to_rsvp_target' || contentType == 'profile_view' || contentType == 'connection_checkedin_to_rsvp_target' ||
                    contentType == 'connection_checkedin_to_checkedin_target' || contentType == 'connection_rsvped_to_non_rsvp_target') {
                const userProfile = notification.userProfile;
                userProfile && notification.set({
                    'photo-url': userProfile.photoUrl,
                    'name': userProfile.firstName + ' ' + userProfile.lastName
                });
            }
        });
    },

    markAsRead: function() {

        this.each(function(notification){
            const success = () => {
                notification.set('read', true);
                Backbone.trigger('fetchBadge');
            };

            const error = (e) => console.error('@@@ error in markAsRead', e);

            Backbone.ajax({
                url: config.baseV2Url + '/messages/read',
                method: 'PUT',
                success: success,
                error: error,
                data: [notification.get('id')]
            });
        });
    }
});



export default NotificationsCollection;

